// extracted by mini-css-extract-plugin
module.exports = {"changePassword":"changePassword_changePassword__2EDPh"};